import { render, staticRenderFns } from "./CarouselChevron.vue?vue&type=template&id=4fb75014&"
import script from "./CarouselChevron.vue?vue&type=script&lang=js&"
export * from "./CarouselChevron.vue?vue&type=script&lang=js&"
import style0 from "./CarouselChevron.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fb75014')) {
      api.createRecord('4fb75014', component.options)
    } else {
      api.reload('4fb75014', component.options)
    }
    module.hot.accept("./CarouselChevron.vue?vue&type=template&id=4fb75014&", function () {
      api.rerender('4fb75014', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/product-components/components/NuHomeCloneProductCarousel/CarouselChevron.vue"
export default component.exports